/**
 * @name setLoading.js
 * @description ローディング処理
 */
import gsap from "gsap";
gsap.config({ nullTargetWarn: false, });

//img要素を取得
let imgArray = [...document.querySelectorAll('img')]

//クラス名
let classNames = {
    text: ['--js_fvAnim-text'],
    line: ['--js_fvAnim-line'],
    img: ['--js_fvAnim-img'],
    alpha: ['--js_fvAnim-alpha'],
    move: ['--js_fvAnim-move'],
}

//プロパティ
const setPropaty = () => {
    return {
        html: document.documentElement,
        body: document.querySelector('body'),
        splash: document.querySelector('.splash'),
        splashLogo: document.querySelector('.splash__item'),
        text: document.querySelectorAll('.--js_fvAnim-text'),
        line: document.querySelectorAll('.--js_fvAnim-line'),
        img: document.querySelectorAll('.--js_fvAnim-img'),
        alpha: document.querySelectorAll('.--js_fvAnim-alpha'),
        move: document.querySelectorAll('.--js_fvAnim-move'),
    }
}

//指定のクラスを削除
const removeClass = (el, className) => el.forEach(el => el.classList.remove(className));

// 非同期関数（async function）loadImagesを宣言
async function loadImages(imgUrls) {
    const promises = [];
    const images = [];

    // 画像ファイルを1枚ずつ読み込み
    imgUrls.forEach((url) => {
        // 画像読み込みimg.src = "***.jpg"; の処理は非同期なのでPromiseオブジェクトにする
        let promise = new Promise((resolve) => {
            // イメージオブジェクト生成
            const img = new Image();
            // 画像読み込み完了後の処理
            img.addEventListener("load", () => resolve());// 読み込み処理が完了したことをPromise（変数promise）に伝える
            img.src = url.src;	// 画像読み込み開始
            images.push(img);	// イメージオブジェクトを配列に格納
        });
        promises.push(promise);		// 画像毎のPromiseオブジェクトを配列に格納
    });
    await Promise.all(promises);	// awaitはasync宣言された場合利用可能: Promise.all()の処理を待っている
    // Promise.all: 全てのPromiseが解決したか？
    return images;
}

/**
 * @name setLoading.js
 */
export function setLoading(lenis) {
    //プロパティ読み込み
    let { html, body, splash, splashLogo, text, line, img, alpha, move } = setPropaty();
    let props = { duration: 1.2, ease: 'expo.inOut', overwrite: true, }
    const tl = gsap.timeline();

    //読み込み開始時の処理
    const __incomplate = () => {
        gsap.to(body, { opacity: 1, duration: 1.2, ease: 'expo.out', overwrite: true });
    }

    //指定したクラスの削除処理
    const __removeClass = () => {
        removeClass(text, ...classNames.text)
        removeClass(line, ...classNames.line)
        removeClass(img, ...classNames.img)
        removeClass(alpha, ...classNames.alpha)
        removeClass(move, ...classNames.move)
    }

    //読み込み終了時の処理
    const __complate = () => {
        html.dataset.state = "";
        lenis.start();
        splash.remove();
        __removeClass();
    }

    //アニメーション処理
    const __animation = (anim = 'on' | 'off') => {

        //FVアニメーション
        let onAnim = () => tl.to(splashLogo, { opacity: 1, ...props, onStart: () => __incomplate() })
            .to(splash, { opacity: 0, ...props, }, ">")
            .to(text, { y: 0, ...props, stagger: { each: 0.005, from: "random", } }, "<0.5")
            .to(line, { scale: 1, ...props }, "<0.5")
            .to(img, { scale: 1, opacity: 1, ...props }, "<0.5")
            .to([alpha, move], { opacity: 1, y: 0, ...props, stagger: 0.05, onComplete: () => __complate() }, "<")

        //共通アニメーション
        let offAnim = () => tl.to(splash, { opacity: 0, ...props, onStart: () => { __removeClass(); __incomplate(); }, onComplete: () => __complate() })

        anim === 'on' ? onAnim() : offAnim();
    }

    //アニメーション集約
    const __init = () => {
        lenis.stop();
        text.length !== 0 ? __animation('on') : __animation('off');
    };

    //読み込み処理
    window.addEventListener("load", async () => {
        let $myWindow = "visited";
        if (window.name.indexOf($myWindow) != -1) {
            await loadImages(imgArray) && __animation('off');
        } else {
            window.name = $myWindow;
            await loadImages(imgArray) && __init()
        }
    });
}